import type { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSelector } from 'src/services/redux';
import { selectIsAuthorized, selectMustSetPassword, selectPrivacyPolicyAccepted } from './selectors';

export const AuthRequired: FC<any> = ({ children }) => {
  const isAuthorized = useSelector(selectIsAuthorized);
  const mustSetPassword = useSelector(selectMustSetPassword);
  const privacyPolicyAccepted = useSelector(selectPrivacyPolicyAccepted);
  const location = useLocation();

  if (!isAuthorized) {
    const next = location.pathname + location.search + location.hash;
    return <Navigate to={`/auth/login?next=${encodeURIComponent(next)}`} replace />;
  }

  if (!privacyPolicyAccepted) {
    return <Navigate to="/privacy-policy" state={{ from: location }} replace />;
  }

  if (mustSetPassword) {
    return <Navigate to="/change-password" state={{ from: location }} replace />;
  }

  return children;
};
